import GoalActivity from "./GoalActivity";
import ListActivity from "./ListActivity";
import PromptActivity from "./PromptActivity";
import UserBookActivity from "./UserBookActivity";

export default {
  GoalActivity,
  ListActivity,
  PromptActivity,
  UserBookActivity,
};
